import React, { useState } from 'react'
import injectSheet from 'react-jss'
import TextPreview from './TextPreview'
import ImageVideoPreview from './ImageVideoPreview'
import PanoPreview from './PanoPreview'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import TouchTiltElement from './TouchTiltElement'
import IconAndTitlePreview from './IconAndTitlePreview'

const ANIMATION_DURATION = 0.3

const style = theme => ({
    large: {
        '@media (max-width: 730px)': {
            display: 'none',
        },
    },
    small: {
        position: 'relative',
        zIndex: 999,
        color: '#fff',
        fontSize: '12px',
        display: 'none',
        '& p': {
            overflow: 'hidden',
            display: ' -webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
        },
        '@media (max-width: 730px)': {
            display: 'block',
        },
    },
    wrapper: {
        height: ({ previewType }) => previews[previewType].height,
        width: ({ previewType }) => previews[previewType].width,
        '@media (max-width: 730px)': {
            height: 'auto !important',
            width: 'auto !important',
        },
        cursor: 'pointer',
        zIndex: 501,
        position: 'relative',
        animationName: ({ isVisible }) => (isVisible ? 'mountAnimation' : 'unmountAnimation'),
        animationDuration: `${ANIMATION_DURATION}s`,
        animationDelay: '0s',
        animationIterationCount: '1',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'forwards',
    },
    '@keyframes mountAnimation': {
        '0%': {
            opacity: 0,
            top: 20,
        },
        '100%': {
            opacity: 1,
            top: 0,
        },
    },
    '@keyframes unmountAnimation': {
        '0%': {
            opacity: 1,
            top: 0,
        },
        '100%': {
            opacity: 0,
            top: 20,
        },
    },
})

const previews = {
    text: {
        height: 200,
        width: 400,
        component: TextPreview,
    },
    photo: {
        height: 376,
        width: 376,
        component: ImageVideoPreview,
    },
    panorama: {
        height: 244,
        width: 522,
        component: PanoPreview,
    },
    get video() {
        return previews.photo
    },
}

const props = withProps(({ onMouseLeave, onUnmount }) => ({
    handleOnMouseLeave: _ => onUnmount && onUnmount(onMouseLeave, ANIMATION_DURATION * 1000),
}))

const Preview = ({ classes, previewType, onClick, title, description, mediaUrl, handleOnMouseLeave }) => {
    const [imgDimensions, setImgDimensions] = useState({
        height: 0,
        width: 0,
    })

    const { height, width, component: Component } = previews[previewType]
    return (
        <div
            className={classes.wrapper}
            onClick={onClick}
            onMouseLeave={handleOnMouseLeave}
            style={{
                marginTop: imgDimensions.height / 4,
            }}
        >
            {(previewType === 'photo' || previewType === 'video') && (
                <>
                    <div className={classes.large}>
                        <TouchTiltElement height={imgDimensions.height} width={imgDimensions.width} type={previewType}>
                            <Component
                                {...{
                                    title,
                                    description,
                                    mediaUrl,
                                    height,
                                    width,
                                    imgDimensions,
                                }}
                                dimensionsCallback={setImgDimensions}
                            />
                        </TouchTiltElement>
                    </div>
                    <div className={classes.small}>
                        <IconAndTitlePreview height={'auto'} width={'auto'} type={previewType}>
                            <p>{title}</p>
                        </IconAndTitlePreview>
                    </div>
                </>
            )}
            {previewType === 'text' && (
                <>
                    <div className={classes.large}>
                        <Component
                            {...{ title, description, mediaUrl, height, width }}
                            onMouseLeave={handleOnMouseLeave}
                        />
                    </div>
                    <div className={classes.small}>
                        <IconAndTitlePreview height={'auto'} width={'auto'} type={previewType}>
                            <p>{title}</p>
                        </IconAndTitlePreview>
                    </div>
                </>
            )}
            {previewType !== 'photo' && previewType !== 'video' && previewType !== 'text' && (
                <>
                    <div className={classes.large}>
                        <TouchTiltElement height={height} width={width} type={previewType}>
                            <Component {...{ title, description, mediaUrl, height, width }} />
                        </TouchTiltElement>
                    </div>
                    <div className={classes.small}>
                        <IconAndTitlePreview height={'auto'} width={'auto'} type={previewType}>
                            <p>{title}</p>
                        </IconAndTitlePreview>
                    </div>
                </>
            )}
        </div>
    )
}

export default compose(injectSheet(style), props)(Preview)
